<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { useMoment } from "@/stores/moment";
import { showSuccessToast } from "vant";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const user = useGlobalUser();
const loadingAiContent = ref(false);
const momentStore = useMoment();

const changeBlockAiContent = async () => {
  loadingAiContent.value = true;
  await user.updateUserApi({
    isShowAiContent: !user.user.isShowAiContent,
  });
  showSuccessToast(t("Message.settingSuccess"));
  loadingAiContent.value = false;
  momentStore.initMomentListIfEmpty(true, 1);
  momentStore.initMomentListIfEmpty(true, 2);
};
</script>
<template>
  <div class="lg:pt-[var(--top-nav-height)]">
    <ThreadsNav :show-center="false" class="lg:hidden" show-back />
    <div class="flex flex-col gap-4 text-sm">
      <div class="px-4 font-bold text-lg">
        {{ $t("setting.content") }}
      </div>
      <VanCellGroup inset>
        <VanCell :title="$t('setting.isBlockAiContent')">
          <template #value>
            <VanSwitch
              :model-value="!user.user.isShowAiContent"
              :loading="loadingAiContent"
              @change="changeBlockAiContent"
            />
          </template>
        </VanCell>
      </VanCellGroup>
    </div>
  </div>
</template>
